import { render, staticRenderFns } from "./DamageType.vue?vue&type=template&id=75859480&"
import script from "./DamageType.vue?vue&type=script&lang=js&"
export * from "./DamageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports